<template>
    <div id='next-location' class='d-flex flex-column justify-content-between' style='height: 100%; overflow: auto'>
        <div class='container'>
            <h5> <fa-icon icon="chevron-left" @click="showPreviousPage" /> For the next month?</h5>
            <p>Pick a country you would want us to create the next poll for. And we will choose the country that was picked the most.</p>

            <div class='content'>
                <div 
                v-for="item in locations"
                :key="item.id" >
                    <div :class="{option: true, highlight: item.id == picked}" @click="pick(item.id)">
                        <div class='bar' :style="barStyle(item)" />
                        <div class='content d-flex justify-content-between align-items-center'>
                            <span class='text'>{{ item.name }} </span>
                            <span class='votes' v-if="picked"> {{ item.votes }} {{ item.votes == 1 ? 'vote' : 'votes' }}</span>
                        </div>
                    </div>
                </div>

                <a href='javascript: ' style='float: right;' @click="skip">Skip</a>
            </div>

        </div>

        <div class='container' style='margin-bottom: 20px' v-if="picked"><NextPage @click="submit" text="Hear from us" /></div>
    </div>
</template>

<script>
import NextPage from "../widgets/NextPage";
import http from "../../lib/http.ts"
export default {
    name: 'next-location',
    components: {NextPage},
    props: {
        location: {required: true}
    },

    data() {
        return {
            locations: [],
            totalVotes: 0,
            maxVotes: 0,
            picked: null
        }
    },

    mounted(){
        this.run()
    }, 

    methods: {

        barStyle(item){
            if(!this.picked) 
                return {width: "0%"}
            let width = Math.min((item.votes / this.maxVotes) * 100, 90);
            return {
                width: this.picked ? (width + "%") : 0
            }
        },

        run() {
            http().get(`/locations/${this.location.id}/next`).then(r => {
                this.locations = r.data.results
                this.totalVotes = Math.max(r.data.total, 1)
                this.maxVotes = r.data.max
            })
        },

        pick(id){
            this.picked = id;
        },

        submit(){
            http().post("/locations/next/pick", {location_id: this.picked})
            this.showNextPage();
        },

        showPreviousPage() {
            this.$emit('show-page', 'results')
        },

        showNextPage(){
            this.$emit('show-page', 'subscribe')
        },

        skip(){
            this.$ga.event('Button', 'Skip', 'Next Location');
            this.showNextPage();
        }

    }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/style-colors";

    .container {
        padding-top: 40px;
        .content {max-width: 600px}
    }

    .option {
        position: relative;
        cursor: pointer;
        background-color: white;
        height: 60px;
        border-radius: 30px;
        border: 1px solid $color-grey;
        margin-bottom: 10px;

        .bar {
            position: absolute;
            z-index: 1;
            top: 0; left: 0;
            height: 100%;
            background-color: $color-blue;
            border-radius: 30px;
            transition: width 0.3s;
        }

        .content {
            position: relative;
            z-index: 2;
            height: 100%;
            padding: 0 30px;
            span.text {font-weight: 700;}
            span.votes {font-size: 12px}
        }
    }
    .option:hover, .option.highlight {border: 2px solid #FFD1AA;}

     @media (max-width: 767.98px) { 

        .container {
            padding-top: 20px;
        }
    }
</style>